import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonTheme, TagTheme, ToggleSwitchStatus, IconPosition } from '@fcom/ui-components';
import { Category, SubCategory } from '@fcom/dapi/api/models';
import { getIconForServiceCategory } from '@fcom/dapi/utils';

@Component({
  selector: 'fin-bundle-offers-toggle',
  templateUrl: './bundle-offers-toggle.component.html',
  styleUrls: ['./bundle-offers-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BundleOffersToggleComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconPosition = IconPosition;
  readonly TagTheme = TagTheme;
  readonly ToggleSwitchStatus = ToggleSwitchStatus;
  readonly ButtonTheme = ButtonTheme;

  @Input({ required: true })
  active: boolean;

  @Input({ required: true })
  category: Category;

  @Input({ required: true })
  subCategoryForTranslations: SubCategory;

  @Output()
  bundleOffersToggled: EventEmitter<boolean> = new EventEmitter();

  emitToggle(toggled: boolean): void {
    this.bundleOffersToggled.emit(toggled);
  }

  protected readonly Category = Category;
  protected readonly getIconForServiceCategory = getIconForServiceCategory;
}
